import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Auth } from "@aws-amplify/auth";
import { BUTTON_SIZES, Button } from "../components/Button";
import AuthInput from "components/AuthInput";
import AuthLayout from "components/AuthLayout";
import { authSubmitButtonStyles } from "utils/constants";

const SetNewPassword = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  const { handleSubmit, handleChange, touched, errors, values } = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: ""
    },
    validationSchema: SetNewPasswordSchema,
    validateOnChange: true,
    validateOnMount: false,
    validateOnBlur: false,
    onSubmit: async ({
      newPassword,
      currentPassword
    }: {
      newPassword: string;
      currentPassword: string;
    }) => {
      try {
        if (!email) {
          throw new Error("Email is required");
        }
        setSubmitting(true);
        const cognitoUser = await Auth.signIn(email, currentPassword);
        if (cognitoUser.challengeName === "NEW_PASSWORD_REQUIRED") {
          await Auth.completeNewPassword(cognitoUser, newPassword);
        }
        return navigate("/login");
      } catch (error: any) {
        setError(error.message);
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <>
      <Helmet>
        <title>Pointment | Set New Password</title>
        <meta property="og:title" content="Pointment | Reset Password" />
      </Helmet>
      <AuthLayout title="Set New Password" error={error} setError={setError}>
        <form onSubmit={handleSubmit}>
          <AuthInput
            type="password"
            name="currentPassword"
            label="Current Password"
            placeholder="Current Password"
            value={values.currentPassword}
            onChange={handleChange}
            touched={touched}
            errors={errors}
          />
          <AuthInput
            type="password"
            name="newPassword"
            label="New Password"
            placeholder="New Password"
            value={values.newPassword}
            onChange={handleChange}
            touched={touched}
            errors={errors}
          />
          <div className="flex lg:flex-row flex-col justify-between lg:items-center">
            <Button
              className={`${authSubmitButtonStyles} !w-full`}
              text={"Set New Password"}
              type="submit"
              size={BUTTON_SIZES.MEDIUM}
              submitting={submitting}
              disabledOnSubmit
            />
          </div>
        </form>
      </AuthLayout>
    </>
  );
};

const SetNewPasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("This field is required"),
  newPassword: Yup.string().required("This field is required")
});

export default SetNewPassword;
